import React from 'react';
import ReactGA from "react-ga4";
import ConModalEce from './ConModalEce.js';

class Video extends React.Component {
    componentWillMount() {
        let ga_track_ids = '';
        ga_track_ids = this.props.GATrackingId;

        let GA_trackId = ga_track_ids ? ga_track_ids.split(',') : [];

        window.addEventListener('message', function (e) {
            try {
                var height = JSON.parse(e.data);

                if (height.action == 'portrait_video') {
                    if (document.querySelector('.video-object').style.maxWidth == '') {
                        document.querySelector('.video-object').style.maxWidth = '350px';
                        document.querySelector('.video-object').style.aspectRatio = '9/16';
                        document.querySelector('.video-object').style.height = 'auto';
                    }
                } else if (height.action == 'landscape_video')
                    document.querySelector('.video-object').style.cssText = '';

                if (height.body_height < 230)
                    return;

                var elem = document.getElementById('videoIframe');
                if (height.body_height) {
                    elem.style.height = height.body_height + 'px';
                    elem.parentElement.classList.remove("only-video");
                }

                if (height.action == 'vb_active') {
                    elem.parentElement.style.cssText = `height:${height.body_height + "px !important"}; padding-bottom:unset !important`;
                }

                if (height.action == 'video_ga_data' && GA_trackId.length != 0) {

                    const trackingObjects = GA_trackId.map(trackingId => ({ trackingId }));
                    ReactGA.initialize(trackingObjects);

                    let data = height.video_data;
                    if (data.message.action == "media-started") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "start",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })

                    } else if (data.message.action == "media-played") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "play",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    } else if (data.message.action == "media-paused") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "stop",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    } else if (data.message.action == "media-completed") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "end",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    }
                }
            }
            catch (e) {
                console.log(e)
            }
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.videoSrc !== this.props.videoSrc) {
            var elem = document.getElementById('videoIframe');
            elem.parentElement.classList.add('only-video');

        }
    }
    render() {
        const initializeModal = async (url, condition) => {

            if (condition) {
                try {
                    const modalEce = new ConModalEce({
                        width: "1154px",
                        closeBtn: false,
                        enableMobileFullHeight: true,
                        closeOnOverlayClick: false,
                        iframeUrl: url
                    });

                    window.addEventListener("message", function (event) {
                        var data = event.data;
                        if (data.type === "close_modal" && data.status === true) {
                            modalEce.closeModal();
                        }
                    }, false);
                } catch (error) {
                    console.error("Error loading ConModalEce:", error);
                }
            } else {
                console.log("Condition not met. Modal not initialized.");
            }
        };

        // Example usage
        let props = this.props;
        let source;
        let portraitStyle = null;
        var referrer = props.videoSrc.substring(props.videoSrc.indexOf('referer=') + 8, props.videoSrc.length);

        let isMobile = false;
        if (/Android|webOS|iPhone|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) ||
            (('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
                !(/iPad/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)))) {
            isMobile = true;
        }

        let isLandscape = false;

        if (window.matchMedia("(orientation: landscape)").matches) {
            isLandscape = true;
        }

        if (referrer) {
            if (
                referrer.includes("media.flickfusion") ||
                document.referrer.includes("media.flickfusion")
            ) {

                source = props.videoSrc.replace(
                    'referer=https://media.flickfusion.net',
                    "referer="
                );

            } else if ((referrer) && (referrer != document.referrer)) {
                source = props.videoSrc + document.referrer;
            } else if (referrer == document.referrer) {
                source = props.videoSrc;
            }
        } else if (!referrer) {
            source = props.videoSrc + document.referrer;
        }

        function checkOrientation() {
            if (document.querySelector('.video-object iframe')) {
                if(isMobile && window.matchMedia("(orientation: landscape)").matches){
                    document.querySelector('.video-object').style.maxWidth = 'unset';
                    document.querySelector('.video-object').style.aspectRatio = 'unset';
                    document.querySelector('.video-object').style.height = 'unset';
                    document.querySelector('.video-object iframe').contentWindow.postMessage(JSON.stringify({ action: 'landscape_mode',value:true}), "*");
                }
                else
                    document.querySelector('.video-object iframe').contentWindow.postMessage(JSON.stringify({ action: 'landscape_mode',value:false}), "*");
            }
        }

        if (props.videoOrientation == 'P') {
            portraitStyle = {
                maxWidth: "350px",
                aspectRatio: "9/16",
                height: "auto",
            }

            window.addEventListener("resize", checkOrientation);
            window.addEventListener("load", checkOrientation);

            // source = !isLandscape ?  `${source}&portrait=true` : `${source}`;
            source = `${source}&portrait=true`;

            if (!document.getElementById('nlp-portrait-video-style')) {
            const style = document.createElement('style');
                style.id = 'nlp-portrait-video-style';

            style.textContent = `
                    .video-object.only-video:has(iframe[src*="v.php"]), .video-object:has(iframe[src*="vb.php"]) {
                    max-width: ${portraitStyle.maxWidth};
                    aspect-ratio: ${portraitStyle.aspectRatio};
                    height: ${portraitStyle.height};
                }
            `;

            document.head.appendChild(style);
            }
        }

        let isEce = '';
        if (props.viPlayer === "1") {
            isEce = 'is_ece ';
            source = props.videoSrc;

            portraitStyle = {
                // aspectRatio: isMobile ? "9/16" : "none",
                // height: !isLandscape ? "auto" : ""
            }
        }

        let videoClass = `video-object only-video ${isEce}`;

        return (
            <div>
                <div className={props.viPlayer === "1" ? (!isMobile ? videoClass : (!isLandscape ? videoClass + 'is_mobile is_portrait' : videoClass + ' is_mobile is_landscape')) : 'video-object only-video'}>
                    <iframe id={'videoIframe'} title="ff_video" frameBorder="0" src={props.viPlayer === "1" ? source +'&inline_embed=1' : source} scrolling="no"
                        allowFullScreen="yes" allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe>
                </div>
                {
                    (props.viPlayer === "1") && isMobile ?
                        <div className={!isLandscape ? "expand-icon is-portrait" : "expand-icon"} onClick={() => initializeModal(source, props.viPlayer === "1")}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="" stroke="#736E6E" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8.5V4m0 0h4.5M4 4l5.5 5.5m10.5-1V4m0 0h-4.5M20 4l-5.5 5.5M4 15.5V20m0 0h4.5M4 20l5.5-5.5m10.5 1V20m0 0h-4.5m4.5 0l-5.5-5.5" /></svg>
                            <span>Expand Player</span>
                        </div>

                        : ''

                }
            </div>
        );
    }
}

export default Video;


// WEBPACK FOOTER //
// ./src/components/Video.js